/**
 * Seeded PRNG (mulberry32). The ONLY source of randomness allowed in rules/.
 * Determinism is what makes sims, goldens, and E2E reproducible — see
 * docs/IMPLEMENTATION-PLAN.md.
 */
export interface Rng {
  /** float in [0, 1) */
  next(): number;
  /** integer in [0, n) */
  int(n: number): number;
  /** pick a random element (throws on empty) */
  pick<T>(arr: readonly T[]): T;
  /** current internal state, for serialization */
  state(): number;
}

export function makeRng(seed: number): Rng {
  let a = seed >>> 0;
  const next = (): number => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (n: number) => Math.floor(next() * n),
    pick: <T,>(arr: readonly T[]): T => {
      if (arr.length === 0) throw new Error('pick from empty array');
      return arr[Math.floor(next() * arr.length)] as T;
    },
    state: () => a,
  };
}
